"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[73735],{

/***/ 15011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const MatomoContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (MatomoContext);
//# sourceMappingURL=MatomoContext.js.map

/***/ }),

/***/ 73735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MatomoContext": function() { return /* reexport */ MatomoContext/* default */.Z; },
  "MatomoProvider": function() { return /* reexport */ es_MatomoProvider; },
  "createInstance": function() { return /* reexport */ instance/* default */.Z; },
  "useMatomo": function() { return /* reexport */ useMatomo/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/MatomoContext.js
var MatomoContext = __webpack_require__(15011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/MatomoProvider.js


const MatomoProvider = ({ children, value }) => {
    const Context = MatomoContext/* default */.Z;
    return react.createElement(Context.Provider, { value: value }, children);
};
/* harmony default export */ var es_MatomoProvider = (MatomoProvider);
//# sourceMappingURL=MatomoProvider.js.map
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/instance.js + 3 modules
var instance = __webpack_require__(84336);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/index.js




//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_useMatomo; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/MatomoContext.js
var MatomoContext = __webpack_require__(15011);
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/utils/useOutboundClickListener.js

const useOutboundClickListener = (matomoInstance) => {
    const handleOutboundClick = (event) => {
        const { target } = event;
        if (!(target instanceof HTMLAnchorElement)) {
            return;
        }
        const { href } = target;
        // Check if the click target differs from the current hostname, meaning it's external
        if (
        // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
        !href.match(new RegExp(`^(http://www.|https://www.|http://|https://)+(${window.location.hostname})`))) {
            matomoInstance.trackLink({ href });
        }
    };
    (0,react.useEffect)(() => {
        window.document.addEventListener('click', handleOutboundClick, {
            capture: true,
        });
        return () => window.document.removeEventListener('click', handleOutboundClick, {
            capture: true,
        });
    }, []);
};
/* harmony default export */ var utils_useOutboundClickListener = (useOutboundClickListener);
//# sourceMappingURL=useOutboundClickListener.js.map
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js



function useMatomo() {
    const instance = (0,react.useContext)(MatomoContext/* default */.Z);
    const trackPageView = (0,react.useCallback)((params) => instance === null || instance === void 0 ? void 0 : instance.trackPageView(params), [instance]);
    const trackEvent = (0,react.useCallback)((params) => instance === null || instance === void 0 ? void 0 : instance.trackEvent(params), [instance]);
    const trackEvents = (0,react.useCallback)(() => instance === null || instance === void 0 ? void 0 : instance.trackEvents(), [instance]);
    const trackSiteSearch = (0,react.useCallback)((params) => instance === null || instance === void 0 ? void 0 : instance.trackSiteSearch(params), [instance]);
    const trackLink = (0,react.useCallback)((params) => instance === null || instance === void 0 ? void 0 : instance.trackLink(params), [instance]);
    const enableLinkTracking = (0,react.useCallback)(() => {
        if (instance) {
            utils_useOutboundClickListener(instance);
        }
    }, [instance]);
    const pushInstruction = (0,react.useCallback)((name, ...args) => {
        instance === null || instance === void 0 ? void 0 : instance.pushInstruction(name, ...args);
    }, [instance]);
    return {
        trackEvent,
        trackEvents,
        trackPageView,
        trackSiteSearch,
        trackLink,
        enableLinkTracking,
        pushInstruction,
    };
}
/* harmony default export */ var es_useMatomo = (useMatomo);
//# sourceMappingURL=useMatomo.js.map

/***/ })

}]);